import { atom, selector } from 'recoil';
import * as vodaLend from '../api/vodaLend';

const fetchBusinessList = async () => {
  try {
    return await vodaLend.getBusinessList();
  } catch (error) {
    return { businesses: [] };
  }
};

const businessListDefault = selector({
  key: 'businessListDefault',
  get: async () => await fetchBusinessList()
});

const businessListState = atom({
  key: 'businessListState',
  default: businessListDefault
});

export const businessList = selector({
  key: 'businessList',
  get: async ({ get }) => {

    const d = await get(businessListState);
    return d;
  }
});